import UnderConstruction from "../../errors/under-construction";

const TeamAvailability = (): JSX.Element => {
  return <UnderConstruction />;
};

export default TeamAvailability;
